import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Importa useNavigate
import { IoIosArrowBack } from 'react-icons/io'; // Importamos la flecha
import FiestaSpinner2 from '../../../shared/FiestaSpinner2';

// Componente para el carrusel de imágenes
const Carousel = ({ images, currentImageIndex, setCurrentImageIndex, closeCarousel }) => {
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div className="carousel-overlay">
      <div className="carousel">
        <button onClick={prevImage} className="carousel-btn prev-btn">
          &lt;
        </button>
        <img
          src={images[currentImageIndex]}
          alt="Imagen en grande"
          className="carousel-image"
        />
        <button onClick={nextImage} className="carousel-btn next-btn">
          &gt;
        </button>
        <button onClick={closeCarousel} className="close-btn">Cerrar</button>
      </div>
    </div>
  );
};

const GalleryPage = () => {
  const location = useLocation(); // Obtener el objeto location para acceder al estado de navegación
  const navigate = useNavigate(); // Usamos useNavigate para regresar a la página anterior
  const { images } = location.state || {}; // Acceder al estado

  useEffect(() => {
    // Esto asegura que la página se desplace al inicio
    window.scrollTo(0, 0);
  }, []); // El arreglo vacío significa que se ejecuta solo una vez al montar el componente


  // Verificar en consola lo que recibimos
  console.log("Estado recibido:", location.state);  // Ver todo el objeto recibido
  console.log("Imágenes recibidas:", images);  // Ver específicamente las imágenes

  // Verificar que las imágenes estén bien formadas
  useEffect(() => {
    if (images && images.length > 0) {
      console.log("URLs de las imágenes:", images);
    } else {
      console.log("No se han recibido imágenes válidas.");
    }
  }, [images]);

  // Estado para manejar la imagen que se ve en el carrusel
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isCarouselOpen, setIsCarouselOpen] = useState(false); // Nuevo estado para abrir/cerrar el carrusel

  // Si no hay imágenes, muestra un mensaje de carga
  if (!images || images.length === 0) {
    return <div className="centered-spinner">
    <FiestaSpinner2 />
  </div>;;
  }

  const openCarousel = (index) => {
    setCurrentImageIndex(index);
    setIsCarouselOpen(true);
  };

  const closeCarousel = () => {
    setIsCarouselOpen(false);
  };

  const goBack = () => {
    navigate(-1); // Regresar a la página anterior
    
  };

  return (
    <div className="master-container gallery-page">
      {/* Contenedor para el botón de regresar y el título */}
      <div className="gallery-back">
        <button className="back-btn" onClick={goBack}>
          <IoIosArrowBack size={25} />
        </button>
        <h1 className="gallery">Galería</h1>
      </div>

      <div className="all-images">
        {images.map((img, index) => (
          <div key={index} className="image-container">
            <img
              src={img}
              alt={`Imagen ${index + 1}`}
              onClick={() => openCarousel(index)} // Al hacer clic se muestra la imagen en el carrusel
              className="image-thumbnail"
            />
          </div>
        ))}
      </div>

      {/* Mostrar el carrusel solo si isCarouselOpen es true */}
      {isCarouselOpen && (
        <Carousel
          images={images}
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
          closeCarousel={closeCarousel}
        />
      )}
    </div>
  );
};

export default GalleryPage;
